import React from "react";
import CustomEmptyState from "../../../../ui/CustomEmptyState/CustomEmptyState";

const RoleEmptyState = ({ noRoles, noResults }) => {
  if (noRoles) {
    return (
      <CustomEmptyState
        height={300}
        primary="No roles have been created yet."
        secondary="Start by creating your first role to control access in your system."
      />
    );
  }

  if (noResults) {
    return (
      <CustomEmptyState
        height={200}
        primary="No roles match your search."
        secondary="Try a different search term or clear your search to see all roles."
      />
    );
  }

  return null;
};

export default RoleEmptyState;
